import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DynamicTable from "../../../components/dynamicTable";
import { getAllBroadbandByType } from "../../../services/BroadbandApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import TariffDescriptionDialog from "../../../components/dialogs/TariffDescriptionDialog";
import PaginatedTable from "../../../components/paginatedTable";

const tableHeader = [
  { id: 1, title: "Name", align: "start" },
  { id: 2, title: "High Price", align: "center" },
  { id: 3, title: "12 Month Low", align: "center" },
  { id: 4, title: "18 Month Low", align: "center" },
  { id: 5, title: "24 Month Low", align: "center" },
  { id: 6, title: "36 Month Low", align: "center" },
  { id: 7, title: "Description", align: "center" },
];

const displayRows = [
  "value",
  "high_price",
  "price_length12",
  "price_length18",
  "price_length24",
  "price_length36",
  "tariff_description",
];

const DigitalBroadband = () => {
  const openDescriptionDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allDigital, setAllDigital] = useState([]);

  useEffect(() => {
    fetchAllDigitalBroadBands();
  }, []);

  const fetchAllDigitalBroadBands = async () => {
    try {
      setIsLoading(true);
      const response = await getAllBroadbandByType("digital");
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllDigital(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <Typography
        variant="primaryText"
        component={"h1"}
        fontSize={{ xs: "1.5rem", md: "1.75rem" }}
        mb={2}
      >
        List Of Digital Tariffs
      </Typography>

      <PaginatedTable
        tableData={allDigital}
        displayRows={displayRows}
        tableHeader={tableHeader}
        handleViewTarrifDescription={(row) =>
          openDescriptionDialog.current.openDialog({ row })
        }
      />
      {allDigital?.length === 0 && isLoading === false && (
        <Typography variant="h5" fontWeight={600} textAlign={"center"}>
          No Data Found !
        </Typography>
      )}
      <TariffDescriptionDialog ref={openDescriptionDialog} />
    </Box>
  );
};

export default DigitalBroadband;
